/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M9 12a22 22 0 0 1 2-3.95 12.88 12.88 0 0 1 4.713-4.456A12.876 12.876 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.46 22.46 0 0 1-4 2z"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05M2.5 21.5s.5-3.74 2-5a2.1795 2.1795 0 0 1 2.91.09c.79.78.8 2.07.09 2.91-1.26 1.5-5 2-5 2M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
    />
  </React.Fragment>,
  'Rocket'
);
